import type { Level } from "types";

export const isNotClassroom = (
  learningObjectTypology: Level
) => 
  learningObjectTypology !== "DA_PHYSICAL_CLASS" && learningObjectTypology !== "DA_VIRTUAL_CLASS";
